import { render, staticRenderFns } from "./peoAdd.vue?vue&type=template&id=653bd3f6&scoped=true&"
import script from "./peoAdd.vue?vue&type=script&lang=js&"
export * from "./peoAdd.vue?vue&type=script&lang=js&"
import style0 from "./peoAdd.vue?vue&type=style&index=0&id=653bd3f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653bd3f6",
  null
  
)

export default component.exports